import { useTranslation } from "react-i18next"

import { CustomerEditForm } from "@/components/customers/edit"
import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { DashboardContainer } from "@/components/layout/dashboard-container"
import { Header } from "@/components/layout/header"
import { FRONTEND_ROUTES } from "@/constants"

export function CustomerEditPage() {
  const { t } = useTranslation()

  return (
    <DashboardContainer>
      <Header>
        <AppBreadcrumb
          links={[
            {
              href: FRONTEND_ROUTES.DASHBOARD.href,
              label: t("sidebar.dashboard"),
            },
            {
              href: FRONTEND_ROUTES.CUSTOMERS.href,
              label: t("sidebar.customers"),
            },
            {
              label: t("pages.customers.edit.title"),
            },
          ]}
        />
      </Header>
      <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
        <CustomerEditForm />
      </section>
    </DashboardContainer>
  )
}
